import { BaseComponent } from '@components/base.component';
import { Component, Input } from '@angular/core';
import { FaceoffsService } from '@services/faceoffs.service';
import { Subscription } from 'rxjs';
import {
    FaceoffSeason, FaceoffsGroup,
    FaceoffSubtournament, FaceoffsValueKey,
    PlayerFaceoffsData,
} from '@interfaces/faceoffs.interface';

@Component({
    selector: 'app-player-faceoffs',
    templateUrl: './player-faceoffs.component.html',
})
export class PlayerFaceoffsComponent extends BaseComponent {
    @Input()
    public sportId: number;

    @Input()
    public sportName: string;

    @Input()
    public playerId: number;

    public seasonId: number | null = null;

    public subtournamentId: number | null = null;

    public subscriber: Subscription;

    public data: PlayerFaceoffsData | null = null;

    public constructor(
        private faceoffsService: FaceoffsService,
    ) {
        super();
    }

    protected readonly console = console;

    public groups: FaceoffsGroup[] = [
        'total',
        'shorthanded',
        'evenstrength',
        'powerplay',
    ];

    public values: FaceoffsValueKey[] = [
        'won',
        'lost',
        'total',
        'win_pct',
    ];

    ngOnInit(): void {
        this.load();
    }

    public ngOnDestroy(): void {
        this.subscriber.unsubscribe();
    }

    private async load(): Promise<any> {

        try {
            const data = await this.faceoffsService.getPlayerFaceoffs(
                this.playerId,
                this.seasonId,
                this.subtournamentId,
            );

            this.subscriber = data.subscribe((data: PlayerFaceoffsData) => {
                this.seasonId = data.selected.season_id ?? null;
                this.subtournamentId = data.selected.subtournament_id ?? null;
                this.data = data;
            });
        } catch (e) {
            // console.log(e);
        }
    }


    get selectedSeason(): FaceoffSeason | null {
        return this?.data?.seasons.find((item: FaceoffSeason) => item.season.id === this.seasonId) ?? null;
    }

    get seasonName(): string | null {
        if (this.seasonId === null) {
            return null;
        }

        const season = this.selectedSeason;

        return season ? season.season.name : null;
    }

    get subtournamentName(): string | null {
        if (this.seasonId === null || this.subtournamentId === null) {
            return null;
        }

        const season = this.selectedSeason;

        if (!season) {
            return null;
        }

        const subtournament = season.subtournaments.find(
            (item: FaceoffSubtournament) => item.id === this.subtournamentId) ?? null;

        return subtournament?.name ?? null;
    }

    public onSeasonChange(e: Event): void {
        this.seasonId = +((e.target as HTMLInputElement).value);
        this.subtournamentId = null;
        this.load();
    }

    public onSubtournamentChange(e: Event): void {
        this.subtournamentId = +((e.target as HTMLInputElement).value);
        this.load();
    }
}
